import { styled } from '@mui/material/styles';
import { ReactElement } from 'react';
import Tooltip from '@/components/Tooltip/Tooltip';
import {
  FileGameGroup,
  formatFileGameGroup,
} from './FileExplorerHelpers';

// Lists a file's games one logical game per line, with its RTP versions,
// so card and list views read the same on hover.
const FileGamesTooltip = ({
  groups,
  children,
}: {
  groups: FileGameGroup[];
  children: ReactElement;
}) => (
  <Tooltip
    title={
      <GamesTooltip>
        {groups.map((group) => (
          <div key={group.key}>{formatFileGameGroup(group)}</div>
        ))}
      </GamesTooltip>
    }
  >
    {children}
  </Tooltip>
);

const GamesTooltip = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
}));

export default FileGamesTooltip;
